import { ModalTemplate, LoadingSpinner } from "@deliverr/ui-facility";
import { FormattedMessage } from "react-intl";
import React from "react";

interface PrintJobLoadingModalProps {
  isPrinting: boolean;
}

export const PrintJobLoadingModal: React.FC<PrintJobLoadingModalProps> = ({ isPrinting }) => {
  if (!isPrinting) {
    return null;
  }

  return (
    <ModalTemplate
      title={
        <FormattedMessage id="sortation.shipToStoreLabel.printJobModal.title" defaultMessage="Printing Labels..." />
      }
    >
      <LoadingSpinner loading={true} />
    </ModalTemplate>
  );
};
